import logo from './logo.svg';
import './App.css';
import Trending from './Components/Page1/Trending/Trending';
import Popular from './Components/Page1/Pouplar/Popular';
import FreeToWatch from './Components/Page1/FreeToWatch/FreeToWatch';
import { Provider } from 'react-redux';
import store from './Store/Reducer';
import MovieDetailsPage from './Components/Page2/MovieDetailsPage';
import {BrowserRouter as Router ,Route,Routes} from "react-router-dom"
import Favorites from './Components/Page3/Favorites';
import Header1 from './Components/Page1/Headers/Header1';
import Search from './Components/Page1/Headers/Search';
function App() {
  
  return (
   
     
      <>
      <Router>
      <Routes>
      <Route exact path="/" element={<div><Header1/><Trending/><Popular/><FreeToWatch/></div>}/>
        <Route exact path="/moviesdetails" element={<MovieDetailsPage/>}/>
        <Route exact path="/favourites" element={<Favorites/>}/>
        <Route exact path="/search" element={<Search/>}></Route>
      </Routes>
      </Router>
      </>
    
  );
}

export default App;
